import { Flow_0_0_2 } from '@flexus/core';

export const SIL_15: Flow_0_0_2 = {
	id: '15',
	name: 'customer_rating_done',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Placeholder'
		},
		viewRoles: {
			0: 'Placeholder'
		}
	},
	startNode: '',
	nodes: {}
};
